import React from 'react';
import Tooltip from './Tooltip';

interface ImageTooltipProps {
  children: React.ReactNode;
  imageUrl: string;
  width?: number;
  height?: number;
  delay?: number;
  className?: string;
}

const ImageTooltip: React.FC<ImageTooltipProps> = ({
  children,
  imageUrl,
  width = 128,
  height = 128,
  delay = 300,
  className = ""
}) => {
  const imageContent = (
    <div className="relative">
      <div 
        className="rounded-lg border-2 border-gray-600 overflow-hidden bg-cover bg-center shadow-2xl bg-gray-900"
        style={{
          width: `${width}px`,
          height: `${height}px`,
          backgroundImage: `url('${imageUrl}')`
        }}
      >
      </div>
    </div>
  );

  return (
    <Tooltip
      content={imageContent}
      position="top"
      delay={delay}
      className={className}
      contentClassName=""
    >
      {children}
    </Tooltip>
  );
};

export default ImageTooltip; 